import React from 'react';

import { ScrollContext } from 'utils/scroll';
import { LanguageContext } from 'utils/localisation';

function RootWrapper({ element }) {
  const lang = process.env.GATSBY_LANG || 'en';
  const root = typeof window !== 'undefined' ? window : null;

  return (
    <ScrollContext.Provider value={root}>
      <LanguageContext.Provider value={lang}>{element}</LanguageContext.Provider>
    </ScrollContext.Provider>
  );
}

export default RootWrapper;
